import './ServiceRequestEarlyRepayment.css';

import InputWidget from '../../../lib/InputWidget/InputWidget';
import {
  pushViewAction,
  getServiceRequestDetailsAction,
} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import {replaceTranslations, serviceRequestPostCall} from '../../../utils/util';

import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  useToastProvider,
} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
const ServiceRequestEarlyRepayment = (props) => {
  const {t} = useTranslation();
  const [repaymentAmount, setRepaymentAmount] = React.useState('');
  const [earlyRepaymentType, setEarlyRepaymentType] = React.useState(null);
  const [submitDisabled, setSubmitDisabled] = React.useState(true);
  const [loader, setLoader] = React.useState(false);

  const {enqueueToast} = useToastProvider();
  React.useEffect(() => {
    if (earlyRepaymentType && repaymentAmount.length > 0) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  }, [repaymentAmount, earlyRepaymentType]);

  const radioButtonHandler = (e) => {
    setEarlyRepaymentType(e.target.value);
  };
  const earlyRepaymentRequestHandler = () => {
    setSubmitDisabled(true);
    setLoader(true);
    let reqBody = {};
    if (props.selectedParty) {
      reqBody.party = props.selectedParty;
    }

    serviceRequestPostCall(
      {
        earlyRepaymentReqAmount: repaymentAmount,
        contractNumber: props.contractNumber,
        partialRepaymentType: earlyRepaymentType,
        requestType: 'Partial early repayment',
        countryCode: props.country,
        userEmail: props.userDetails.email,
        ...reqBody,
      },
      enqueueToast,
      'EARLY_REPAYMENT_REQUEST',
      () => {
        setLoader(false);
        setSubmitDisabled(false);
      },
      replaceTranslations(
        t('SERVICE_REQUEST_LIMIT'),
        50,
        t('Partial_early_repayment')
      ),
      t('SERVICE_REQUEST_SUCCESS'),
      t('SERVICE_REQUEST_CREATION_FAILED'),
      () => {
        appStore.dispatch(getServiceRequestDetailsAction(null));
        appStore.dispatch(pushViewAction('serviceRequestDashboard'));
      }
    );
  };
  const renderPartialEarylyPayment = () => {
    return (
      <div className={'ServiceRequestEarlyRepaymentWrapper'}>
        <div className={'ServiceRequestCard'}>
          <div className="serviceRequestHeader">
            <div className={'title'}>{t('PARTIAL_EARLY_REPAYMENT_LOAN')}</div>
          </div>
          <div className={'subTitle'}>
            {t('PARTIAL_EARLY_REPAYMENT_LOAN_SUBTITLE')}
          </div>
        </div>
        <Box pl={4} pr={4} pb={4}>
          <Card className="cardCustom">
            <CardContent className="ChangeEarlyRepaymentCard">
              <Typography gutterBottom variant="h5" required={true}>
                {t('TYPE_OF_PARTIAL_REPAYMENT')}
                <span className="requiredText">*</span>
              </Typography>
              <RadioGroup
                name="group1"
                data-testid="radio-button-id"
                className="earlyRepaymentType"
                onClick={(repaymentType) => radioButtonHandler(repaymentType)}
              >
                <FormControlLabel
                  control={<Radio />}
                  label={t('REDUCE_TERM')}
                  value="Reduce Term"
                />
                <FormControlLabel
                  control={<Radio />}
                  label={t('REDUCE_INSTALLMENT_AMOUNT')}
                  value="Reduce installment amount"
                />
              </RadioGroup>
              <div>
                <InputWidget
                  id="change-early-repayment-number"
                  className="ChangeEarlyRepaymentField"
                  label={t('ENTER_AMOUNT_FOR_EARLY_REPAYMENT')}
                  type="number"
                  data-testid="change-early-repayment-number"
                  required={true}
                  value={repaymentAmount}
                  setValue={setRepaymentAmount}
                  customError={true}
                  error={repaymentAmount.length > 0}
                  helperText={t('EARLY_REPAYMENT_PLACEHOLDER')}
                />
              </div>

              {/*<div className={'subTitle'}>{t('MINIMUM_AMOUNT_TEXT')}</div>*/}
            </CardContent>
          </Card>
          <div className="buttonControls">
            <Button
              id="cancelButton"
              onClick={() => props.cancelButtonClick(null)}
              variant="secondary"
            >
              {t('CANCEL')}
            </Button>

            <Button
              id="primaryBtn"
              onClick={() => earlyRepaymentRequestHandler()}
              variant="primary"
              data-testid="primaryBtn-submit"
              disabled={earlyRepaymentType ? submitDisabled : true}
              startIcon={
                loader && (
                  <CircularProgress size="small" style={{color: '#000'}} />
                )
              }
            >
              {t('SUBMIT')}
            </Button>
          </div>
        </Box>
      </div>
    );
  };
  return <>{renderPartialEarylyPayment()}</>;
};

export const mapStateToProps = (state) => {
  return {
    country: state.appStates.allContracts?.countryCode,
    userDetails: state.appStates.userDetailsInfo,
  };
};
export default connect(mapStateToProps)(ServiceRequestEarlyRepayment);
